const STATUSES = {
	UPLOADING: {"value": 0, "name": "Uploading"},
	UPLOADED: {"value": 1, "name": "Uploaded"},
	PROCESSING: {"value": 2, "name": "Processing"},
	PROCESSED: {"value": 3, "name": "Processed"},
	FAILED: {"value": 4, "name": "Failed"}
}

export default STATUSES